
export default {
  data() {
    return {
      options: [
        {
          name: "logo",
          label: "Logo",
          type: "image",
          size: "48x48",
        },
        {
          name: "company",
          label: "Naziv tvrtke",
          type: "text",
        },
        {
          name: "rating",
          label: "Ocjena (1-5)",
          type: "text",
        },
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
        {
          name: "name",
          label: "Ime",
          type: "text",
        },
        {
          name: "position",
          label: "Pozicija",
          type: "text",
        },
        {
          name: "link",
          label: "Poveznica",
          type: "link",
        },
      ],
    };
  },
};
